import type { OptionItemType } from './label-type'

export const tabMapOptions: OptionItemType[] = [
  {
    label: '标签值管理',
    value: 'labelValue',
  },
  {
    label: '标签组管理',
    value: 'labelGroup',
  },
]

export const fromValueList: OptionItemType[] = [
  // {
  //   label: '标签值名',
  //   value: 'name',
  // },
  {
    label: '标签值id',
    value: 'id',
  },
]

export const visibleOptions: OptionItemType[] = [
  {
    value: '',
    label: '全部',
  },
  {
    value: 1,
    label: '素材仓库',
  },
]
export const statusesOptions: OptionItemType[] = [
  {
    label: '待启用',
    value: 1,
  },
  {
    label: '使用中',
    value: 2,
  },
  {
    label: '已废弃',
    value: 3,
  },
]

export const fromGroupList: OptionItemType[] = [
  // {
  //   label: '标签组名',
  //   value: 'name',
  // },
  {
    label: '标签组id',
    value: 'id',
  },
]

export const categoriesOptions: OptionItemType[] = [
  {
    label: '全部',
    value: 0,
  },
  {
    label: '元素特征标签',
    value: 2,
  },
]

export const publicOptions: OptionItemType[] = [
  {
    label: '是，外部可用',
    value: 1,
  },
  {
    label: '否，仅内部使用',
    value: 2,
  },
]

export const typesOptions: OptionItemType[] = [
  {
    label: '龙骨',
    value: 7,
  },
  {
    label: '视频',
    value: 1,
  },
  {
    label: '图片',
    value: 2,
  },
  {
    label: '动图',
    value: 3,
  },
  {
    label: '音频',
    value: 4,
  },
  {
    label: '粒子',
    value: 5,
  },
  {
    label: '字体',
    value: 6,
  },
  {
    label: '花字',
    value: 8,
  },
  {
    label: '转场',
    value: 9,
  },
  {
    label: '滤镜',
    value: 10,
  },
  {
    label: '动画',
    value: 11,
  },
  {
    label: '预设',
    value: 12,
  },
  {
    label: '片段',
    value: 13,
  },
  {
    label: '模型',
    value: 14,
  },
  {
    label: '动作',
    value: 15,
  },
]

export enum Operation {
  // 删除
  DELETE = 'delete',
  // 新增
  ADDLABEL = 'addLabel',
  // 修改
  REVISE = 'revise',
  // 批量修改
  BATCHDE = 'batchRevise',
}
